import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Components
import SideMenu from "../SideMenu/SideMenu";
import { PageWrapper } from "../PageSpecificComponents";
import NotificationCenter from "../Notifications/NotificationCenter";
import NotificationsCounter from "../UI/NotificationCounter/NotificationCounter";
import GlobalServiceDrawers from "../GlobalServiceDrawers/GlobalServiceDrawers";

// Icons
import { MenuIcon, Logo, BellIcon } from "../../SVGS";

// Actions
import { toggleNotificationsPanel } from "../../redux/actions/notifications.actions";

// Services
import { enableScroll, disableScroll } from "../../utils";

// Hooks
import { useIsMobileLayout } from "../../hooks/useMediaQuery";

// Styles
import { AppShellStyles } from "./appShell.styles";

// Shared layout for all authenticated routes: owns the mobile drawer open state,
// renders a mobile-only top bar with the hamburger, and wraps the SideMenu +
// page content. On desktop the top bar is hidden and behaviour is unchanged.
const AppShell = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isMobileLayout = useIsMobileLayout();
  const dispatch = useDispatch();
  const { unreadCount } = useSelector(state => state.notifications);

  const openMenu = () => {
    setIsMobileMenuOpen(true);
    disableScroll();
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
    enableScroll();
  };

  // If the viewport grows back to desktop while the drawer is open, force it
  // closed and release the body scroll lock so desktop isn't left stuck.
  useEffect(() => {
    if (!isMobileLayout && isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
      enableScroll();
    }
  }, [isMobileLayout, isMobileMenuOpen]);

  return (
    <AppShellStyles>
      <header className="mobileTopBar">
        <button
          type="button"
          className="hamburger"
          aria-label="Open menu"
          onClick={openMenu}
        >
          <MenuIcon />
        </button>
        <Logo className="topBarLogo" />
        <button
          type="button"
          className="topBarBell"
          aria-label="Notifications"
          onClick={() => dispatch(toggleNotificationsPanel())}
        >
          <BellIcon />
          <NotificationsCounter
            counter={unreadCount}
            className="topBarBellBadge"
          />
        </button>
      </header>

      <div
        className={`drawerBackdrop ${isMobileMenuOpen ? "isOpen" : ""}`}
        onClick={closeMenu}
      />

      <SideMenu isOpen={isMobileMenuOpen} onClose={closeMenu} />
      <NotificationCenter />
      <GlobalServiceDrawers />
      <PageWrapper>{children}</PageWrapper>
    </AppShellStyles>
  );
};

export default AppShell;
